import React, { useEffect,useState, useCallback } from 'react';
import { User, Phone, MapPin, Heart, Bus, Calendar, Hash, UserCheck, Mail, Award, FileText, Activity } from 'lucide-react';
import config from '../config/config';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
const StudentDetailView = () => {
  const { id, invoice_id } = useParams();
  const [activeTab, setActiveTab] = useState('overview');

   const [selectedStudent, setStudentInfo] = useState(null);


// Get the token from localStorage
const getToken = () => localStorage.getItem('token');
const token_ = getToken();
// API base URL (use environment variable or fallback)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config.API_URL+'/api';
   // Fetch student info
  const fetchStudentInfo = useCallback(async () => {
    try {
      const response = await axios.get(`${config.API_URL}/api/students/${id}`, {
        headers: { Authorization: `Bearer ${token_}` },
      });
      const studentData = response.data.student || response.data;
      console.log(studentData);
      setStudentInfo(studentData);
    } catch (err) {
      console.error('Error fetching student info:', err);
    }
  }, []);


  // Create axios instance with auth headers
  const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  
  // Sample student data
  const selectedStudents = {
    id: 'STD001',
    admission_number: 'ADM2024001',
    name: 'John Michael Smith',
    gender: 'M',
    date_of_birth: '2010-05-15',
    class_admitted_to: 'Grade 8',
    status: 'active',
    parent_firstname: 'David',
    parent_lastname: 'Smith',
    parent_surname: 'Johnson',
    contact: '+1 (555) 123-4567',
    email: 'david.smith@email.com',
    physical_address: '123 Oak Street, Springfield, IL 62701',
    health_record: 'No known allergies. Regular checkups completed.',
    transport_option: 'School Bus - Route 12',
    blood_group: 'O+',
    emergency_contact: '+1 (555) 987-6543',
    enrollment_date: '2024-01-10',
    previous_school: 'Lincoln Elementary School',
    gpa: '3.8',
    attendance_rate: '95%',
    guardian_occupation: 'Software Engineer',
    notes: 'Excellent performance in Mathematics and Science. Active member of the school robotics club.'
  };


  useEffect(() => {
    fetchStudentInfo();
  }, [id]);

  const InfoCard = ({ icon: Icon, title, value, color = 'blue' }) => (
    <div className="bg-white rounded-xl p-4 border border-gray-100 hover:shadow-md transition-all duration-300">
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-lg bg-${color}-50`}>
          <Icon className={`w-5 h-5 text-${color}-600`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{title}</p>
          <p className="text-sm font-semibold text-gray-900 break-words">{value}</p>
        </div>
      </div>
    </div>
  );

  const StatCard = ({ label, value, icon: Icon, trend }) => (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100">
      <div className="flex items-center justify-between mb-3">
        <Icon className="w-6 h-6 text-blue-600" />
        {trend && <span className="text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-full">{trend}</span>}
      </div>
      <p className="text-2xl font-bold text-gray-900 mb-1">{value}</p>
      <p className="text-xs font-medium text-gray-600">{label}</p>
    </div>
  );

  const Section = ({ title, children }) => (
    <div className="mb-6">
      <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-gray-200">{title}</h3>
      {children}
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-4">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                {selectedStudent?.firstname.split(' ').map(n => n[0]).join('').slice(0, 2)}
              </div>
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-1">{selectedStudent?.firstname} {selectedStudent?.lastname} {selectedStudent?.surname}</h1>
                <div className="flex items-center gap-3">
                  <span className="text-sm text-gray-600 font-medium"><strong>Class : </strong>{selectedStudent?.class_admitted_to}</span>
                  <span className="text-gray-300">•</span>
                  <span className="text-sm text-gray-600 font-medium"><strong>Admission No# :</strong> {selectedStudent?.admission_number}</span>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    selectedStudent?.status === 'active' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {selectedStudent?.status === 'active' ? '● Active' : '● Inactive'}
                  </span>
                </div>
              </div>
            </div>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm">
              Edit Profile
            </button>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 mb-6 overflow-hidden">
          <div className="flex border-b border-gray-200">
            {[
              { id: 'overview', label: 'Overview', icon: User },
              { id: 'academic', label: 'Academic', icon: Award },
              { id: 'health', label: 'Health & Transport', icon: Heart },
              { id: 'notes', label: 'Notes', icon: FileText }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-6 py-4 font-semibold text-sm transition-all ${
                  activeTab === tab.id
                    ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <tab.icon className="w-4 h-4" />
                {tab.label}
              </button>
            ))}
          </div>

          <div className="p-6">
            {/* Overview Tab */}
            {activeTab === 'overview' && (
              <div>
                <Section title="Personal Information">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <InfoCard icon={Hash} title="Student Admission" value={selectedStudent?.admission_number} color="blue" />
                    <InfoCard icon={User} title="Gender" value={selectedStudent?.gender === 'M' ? 'Male' : 'Female'} color="purple" />
                    <InfoCard icon={Calendar} title="Date of Birth" value={selectedStudent?.date_of_birth} color="green" />
                    <InfoCard icon={Calendar} title="Enrollment Date" value={selectedStudent?.enrollment_date} color="orange" />
                    <InfoCard icon={Activity} title="Blood Group" value={selectedStudent?.blood_group} color="red" />
                    <InfoCard icon={Award} title="Previous School" value={selectedStudent?.previous_school} color="indigo" />
                  </div>
                </Section>

                <Section title="Parent/Guardian Information">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <InfoCard 
                      icon={UserCheck} 
                      title="Guardian Name" 
                      value={`${selectedStudent?.parent_firstname} ${selectedStudent?.parent_lastname} ${selectedStudent?.parent_surname}`} 
                      color="blue" 
                    />
                    <InfoCard icon={Phone} title="Contact Number" value={selectedStudent?.contact} color="green" />
                    <InfoCard icon={Mail} title="Email Address" value={selectedStudent?.email} color="purple" />
                    <InfoCard icon={Phone} title="Emergency Contact" value={selectedStudent?.emergency_contact} color="red" />
                    <InfoCard icon={Award} title="Occupation" value={selectedStudent?.guardian_occupation} color="orange" />
                    <div className="md:col-span-1">
                      <InfoCard icon={MapPin} title="Physical Address" value={selectedStudent?.physical_address} color="indigo" />
                    </div>
                  </div>
                </Section>
              </div>
            )}

            {/* Academic Tab */}
            {activeTab === 'academic' && (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <StatCard label="Current GPA" value={selectedStudent?.gpa} icon={Award} trend="+0.2" />
                  <StatCard label="Attendance Rate" value={selectedStudent?.attendance_rate} icon={Activity} trend="+2%" />
                  <StatCard label="Class Rank" value="12/156" icon={Award} />
                </div>
                
                <Section title="Academic Details">
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Student is enrolled in <strong>{selectedStudent?.class_admitted_to}</strong> and maintains excellent academic standing. 
                      Demonstrates strong aptitude in STEM subjects and participates actively in extracurricular activities.
                    </p>
                  </div>
                </Section>
              </div>
            )}

            {/* Health & Transport Tab */}
            {activeTab === 'health' && (
              <div>
                <Section title="Health Information">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <InfoCard icon={Activity} title="Blood Group" value={selectedStudent?.blood_group} color="red" />
                    <InfoCard icon={Phone} title="Emergency Contact" value={selectedStudent?.emergency_contact} color="orange" />
                  </div>
                  <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                    <div className="flex items-start gap-3">
                      <Heart className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">Health Record</h4>
                        <p className="text-sm text-gray-700">{selectedStudent?.health_record}</p>
                      </div>
                    </div>
                  </div>
                </Section>

                <Section title="Transportation">
                  <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
                    <div className="flex items-start gap-3">
                      <Bus className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">Transport Details</h4>
                        <p className="text-sm text-gray-700">{selectedStudent?.transport_option}</p>
                      </div>
                    </div>
                  </div>
                </Section>
              </div>
            )}

            {/* Notes Tab */}
            {activeTab === 'notes' && (
              <div>
                <Section title="Student Notes">
                  <div className="bg-amber-50 rounded-xl p-6 border border-amber-100">
                    <div className="flex items-start gap-3">
                      <FileText className="w-5 h-5 text-amber-600 mt-1 flex-shrink-0" />
                      <div>
                        <p className="text-sm text-gray-700 leading-relaxed">{selectedStudent?.notes}</p>
                      </div>
                    </div>
                  </div>
                </Section>

                <div className="mt-6">
                  <button className="w-full py-3 border-2 border-dashed border-gray-300 rounded-xl text-gray-600 hover:border-blue-400 hover:text-blue-600 transition-colors font-medium">
                    + Add New Note
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetailView;